import { render, staticRenderFns } from "./VagasInteresse.vue?vue&type=template&id=33f65496&scoped=true&"
import script from "./VagasInteresse.vue?vue&type=script&lang=js&"
export * from "./VagasInteresse.vue?vue&type=script&lang=js&"
import style0 from "./VagasInteresse.vue?vue&type=style&index=0&id=33f65496&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f65496",
  null
  
)

export default component.exports